import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import { Divider } from "@material-ui/core";

import { useDispatch } from "react-redux";
import { addProduct } from "../../services/actions";

import { image_ip } from "../../services/constants";
import alt_back from "../../zmall.png";
import AlertDialogSlide from "../Dialog";
import { useCallback } from "react";

import { toast } from "react-toastify";

export default function ItemCard(props) {
  const dispach = useDispatch();
  const nav = useNavigate();
  var details = props.item.details.substring(0, 70);
  // details = details + "...";

  const [success, setSuccess] = useState(false);
  const dialogue_data = {
    yes: "Clear",
    no: "Cancel",
    primary: "Clear Cart",
    secondary: "Products from other stores are in the cart clear the cart?",
  };
  const handleClick = (e, id) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    nav(`/item/${id}`, { state: { product: props.item } });
  };
  // };
  const checkStore = useCallback(
    (e, item) => {
      const previousStore = localStorage.getItem("store_id");
      if (!previousStore) {
        handleToCart(props.item);
      } else if (previousStore !== item.store_id) {
        setSuccess(true);
      } else {
        handleToCart(props.item);
      }
    },
    [props]
  );
  const handleToCart = useCallback(
    (item) => {
      item.quantity = 1;
      var temp = new Object(item);
      temp.specification = [];
      dispach(addProduct(props.item));
      toast.success("Product added !", {
        position: toast.POSITION.TOP_RIGHT,
      });
    },
    [props]
  );
  const style = {
    margin: "auto",
    marginTop: "5px",
  };
  return (
    <Card
      sx={{
        maxWidth: 200,
        width: "300px",
        borderRadius: "5px",
      }}
      style={{ style }}
      elevation={0}
    >
      <CardMedia
        component="img"
        height="140"
        image={`${image_ip}/${props.item.image_url}`}
        onError={({ currentTarget }) => {
          currentTarget.onError = null; // prevents looping
          currentTarget.src = "/zmall.png";
        }}
      />
      <CardContent>
        <Typography
          // gutterBottom
          variant="h5"
          component="div"
          style={{ fontSize: "0.7rem", fontWeight: "bold" }}
        >
          {props.item.name}
        </Typography>
        {/* <Typography
          variant="body2"
          color="text.secondary"
          style={{ fontSize: "0.7rem", height: "30px" }}
        >
          {details}
        </Typography> */}
        <Typography
          variant="body2"
          // color="text.secondary"
          style={{ fontSize: "0.7rem", textAlign: "left" }}
        >
          <span
            style={{
              textDecoration: "line-through",
              fontWeight: "normal",
              color: "gray",
            }}
          >
            {props.item.new_price}
          </span>
          <span style={{ fontWeight: "bold" }}> {props.item.price} </span>
          <span style={{ fontWeight: "normal", color: "gray" }}> ETB</span>
        </Typography>

        {/* <Typography
          variant="body2"
          color="text.secondary"
          style={{ fontSize: "0.7rem", textAlign: "left", fontWeight: "bold" }}
        >
          Br.{props.item.price} ETB
        </Typography> */}
        <Typography
          variant="body2"
          // color="text.secondary"
          style={{ fontSize: "0.7rem", textAlign: "left", fontWeight: "bold" }}
        >
          {props.item.store_name}
        </Typography>
      </CardContent>
      <CardActions style={{ justifyContent: "space-between" }}>
        <ThemeProvider theme={theme}>
          <Button
            size="small"
            onClick={(e) => {
              handleClick(e, props.item._id);
            }}
            color="neutral"
            variant="contained"
            // variant="outlined"
            sx={{
              fontSize: "0.7rem",
              color: "white", // Text color
              borderRadius: "50px", // Border radius
              border: "1px solid white", // Optional border styling
              "&:hover": {
                backgroundColor: "darkred", // Darker red on hover
              },
            }}
          >
            See More
          </Button>

          {props.item.specifications.length == 0 ? (
            <Button
              size="small"
              color="neutral"
              onClick={(e) => {
                checkStore(e, props.item);
              }}
              style={{ fontSize: "0.7rem" }}
            >
              Quick Add
            </Button>
          ) : null}
        </ThemeProvider>
      </CardActions>
      {props.last ? null : <Divider />}
      <AlertDialogSlide
        open={success}
        data={dialogue_data}
        confirm={() => {
          handleToCart(props.item);
          setSuccess(false);
        }}
        not={() => {
          setSuccess(false);
        }}
      />
    </Card>
  );
}
